export default {
  title: 'Sorry',
  error: 'Nothing to see here...',
  notFound: 'The page you were looking for does not exist',
  link: {
    title: 'Back to the home page',
  },
};
